
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"44","viewBox":"0 0 38 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.1867 16.4667L37.7889 9.56755C38.3462 8.72311 37.7467 7.6 36.7333 7.6H24.0667C23.3658 7.6 22.8 7.03422 22.8 6.33333C22.8 4.23911 21.0942 2.53333 19 2.53333H9.91378C9.39022 1.05556 7.98844 0 6.33333 0C4.23911 0 2.53333 1.70578 2.53333 3.8V40.7022H1.26667C0.565778 40.7022 0 41.268 0 41.9689C0 42.6698 0.565778 43.2355 1.26667 43.2355C2.34756 43.2355 10.3191 43.2355 11.4 43.2355C12.1009 43.2355 12.6667 42.6698 12.6667 41.9689C12.6667 41.268 12.1009 40.7022 11.4 40.7022H10.1333V22.8H20.4862C21.0098 24.2778 22.42 25.3333 24.0667 25.3333H36.7333C37.7467 25.3333 38.3462 24.2018 37.7889 23.3658L33.1867 16.4667ZM7.6 40.7022H5.06667V3.8C5.06667 3.09911 5.63244 2.53333 6.33333 2.53333C7.03422 2.53333 7.6 3.09911 7.6 3.8C7.6 4.44178 7.6 40.0435 7.6 40.7022ZM20.2667 20.2667H10.1333V5.06667H19C19.7009 5.06667 20.2667 5.63244 20.2667 6.33333V20.2667ZM24.0667 22.8C23.3658 22.8 22.8 22.2342 22.8 21.5333V9.91378C23.1969 10.0573 23.6191 10.1333 24.0667 10.1333H34.3689L30.6111 15.7658C30.324 16.188 30.324 16.7453 30.6111 17.1676L34.3689 22.8H24.0667Z"}})])
          )
        }
      }
    